import { render, staticRenderFns } from "./take_ownership_modal.vue?vue&type=template&id=a580f72a"
import script from "./take_ownership_modal.vue?vue&type=script&lang=js"
export * from "./take_ownership_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports